import { render, staticRenderFns } from "./SettingMain.vue?vue&type=template&id=a7f14c28&scoped=true&"
import script from "./SettingMain.vue?vue&type=script&lang=js&"
export * from "./SettingMain.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/setting.css?vue&type=style&index=0&id=a7f14c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f14c28",
  null
  
)

export default component.exports